var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarketplaceDarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31_1303)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.57142 15V19.2857C2.57142 21.1793 4.10645 22.7143 5.99999 22.7143H18C19.8936 22.7143 21.4286 21.1793 21.4286 19.2857V15",
    stroke: "#DDE2F1",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.4066 11.4181C6.75461 11.4181 7.95146 10.7967 8.70329 9.83607C9.45514 10.7967 10.652 11.4181 12 11.4181C13.348 11.4181 14.5449 10.7967 15.2967 9.83607C16.0485 10.7967 17.2454 11.4181 18.5935 11.4181C20.8694 11.4181 22.7143 9.64693 22.7143 7.46207C22.7143 6.40712 21.8901 3.12361 18.5935 1.85766C13.4781 1.0985 10.5911 1.09161 5.4066 1.85766C2.10989 3.12361 1.28571 6.40712 1.28571 7.46207C1.28571 9.64693 3.1307 11.4181 5.4066 11.4181Z",
    stroke: "#DDE2F1",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.57142 16.6072V22.7143H15.4286V16.6072C15.4286 15.6604 14.661 14.8929 13.7143 14.8929H10.2857C9.33894 14.8929 8.57142 15.6604 8.57142 16.6072Z",
    stroke: "#DDE2F1",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31_1303"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketplaceDarkIcon);
export default __webpack_public_path__ + "static/media/marketplace-dark-icon.5d5c42c53f51577913c4b52315ea737a.svg";
export { ForwardRef as ReactComponent };